// import Logger from '@ioc:Adonis/Core/Logger';
import Media from './Media';

export default class ResponsiveImage {
  public image?: Media;
  public mobileImage?: Media;

  constructor(data: any) {
    try {
      const { image, mobile_image } = data;

      this.image = image ? new Media(image) : undefined;
      this.mobileImage = mobile_image ? new Media(mobile_image) : this.image;
    } catch (error) {
      // Logger.error(error);
    }
  }
}
